import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { ShadowWrapper } from '../blocks/ShadowWrapper/ShadowWrapper.js';
import { uploaderBlockCtx } from './CTX.js';
export class SolutionBlock extends ShadowWrapper {
  constructor() {
    super(...arguments);
    _defineProperty(this, "requireCtxName", true);
    _defineProperty(this, "init$", uploaderBlockCtx(this));
    _defineProperty(this, "_template", null);
  }
  static set template(value) {
    this._template = value + /** HTML */"<slot></slot>";
  }
  static get template() {
    return this._template;
  }
}